/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Card, CardActions, CardContent, CardHeader, IconButton,
} from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  getIn, useFormikContext,
} from 'formik';
import React, {
  useState,
} from 'react';
import {
  isCustomFormPreview, isFormField,
} from '../../types';
import FieldError from '../../Utils/FieldError';
import FormFieldCondition from '../../Utils/FormFieldCondition';
import {
  FieldPropsCommon, NestedFormFieldValue,
} from '../types';

type Props<T, K extends keyof T> = FieldPropsCommon<T, K> & NestedFormFieldValue<T, K>;

const NestedFormField = <FormModel, FormModelKey extends keyof FormModel>(props: Props<FormModel, FormModelKey>) => {
  const {
    values,
    errors,
    touched,
  } = useFormikContext<FormModel>();

  const {
    fieldOptions,
    title,
    location,
  } = props;

  const error = getIn(errors, location);
  const isTouched = getIn(touched, location);

  const [isExpanded, setExpanded] = useState(true);
  const handleExpandClick = () => {
    setExpanded(!isExpanded);
  };

  return (
    <Card
      style={{
        margin: 8,
        boxShadow: 'none',
        border: 'none',
        backgroundColor: 'transparent',
      }}
    >
      {
        title && (
          <CardHeader
            title={title}
            action={
              fieldOptions.isCollapsible
                ? (
                  <IconButton
                    onClick={() => handleExpandClick()}
                    aria-expanded={isExpanded}
                  >
                    { isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon /> }
                  </IconButton>
                ) : null
            }
          />
        )
      }
    
      <CardContent>
        { isExpanded && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'stretch',
              padding: 0,
            }}
          >
            {
              fieldOptions.formData.map((formField) => {
                if (isCustomFormPreview<FormModel>(formField)) {
                  const CustomComponent = formField.component as any;
                  return (
                    <CustomComponent {...values} />
                  );
                }
                if (isFormField<FormModel, FormModelKey>(formField)) {
                  return (
                    <FormFieldCondition<FormModel, FormModelKey>
                      key={`${location}.${formField.key}`}
                      fieldData={formField as any}
                      location={`${location}.${formField.key}`}
                    />
                  );
                }
                return null;
              })
            }
          </div>
        )}
      </CardContent>
      {
        error && (
          <CardActions>
            <FieldError
              errors={error}
              touched={isTouched}
            />
          </CardActions>
        )
      }
    </Card>
  );
};

export default NestedFormField;
/* eslint-enable @typescript-eslint/no-explicit-any */
